"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authorities = [
    { label: "Super admin", role: "ROLE_ADMIN" },
    { label: "Admin", role: "ROLE_TEAM_MANAGER" },
    { label: "User", role: "ROLE_USER" },
];
